<template>
    <data-table class="table table table-striped"
        ref="table"
                
        :filter-position="tableFilterPosition"
        :columns="columns"
        :data="notifications"
        :loading="isLoading"
        :datatable-options="dataTablesOptions"
        :datatable-classes="['table-bordered']"
                
        @cancel="cancel"
    />
</template>

<script>
    import moment from 'moment';
    
    import api from '../api';
    
    import { promptV2 as prompt } from "../../../Util/prompt";
    import { dateToString } from '../../../Util/time';

    import { 
        bootstrapDangerGrowl as errorGrowl,
        bootstrapInfoGrowl as infoGrowl,
        bootstrapSuccessGrowl as successGrowl 
    } from "../../../Util/growler";
    
    import resourceMixin from "../../../Util/Mixins/resources";
    
    import {defaultContentType, filterPositions, textRenderer, default as DataTable} from "../../../Components/Util/DataTable/DataTable.vue";

    export default {
        name: 'push-notifications-list',
        mixins: [resourceMixin],
        components: {
            DataTable
        },
        created() {
            const vm = this;
            
            vm.reloadNotifications();
            
            api.validateWritePermission().then(
                canWrite => vm.canWrite = canWrite,
                () => vm.canWrite = false
            );
        },
        methods: {
            cancel(notification){
                const vm = this;
                
                const notificationId = notification.id;
                
                //If our notification is already expired by the time the user attempts to cancel
                //mark it as expired and notify the user
                //due to our dates being formatted, we need to explicitly tell moment they are UTC
                if(moment().isAfter(moment.utc(notification.expiresAt))){
                    infoGrowl(vm.resource('PushNotifications_CancelNotification_Failed_AlreadyExpiredMessage'));
                    
                    notification.isExpired = true;
                    vm.reloadDataTable();
                    return;
                }
                
                prompt(
                    vm.resource('PushNotifications_CancelNotification_Prompt_Title'),
                    vm.resource('PushNotifications_CancelNotification_Prompt_Body')
                ).then(
                    () => {
                        api.cancelNotification(notificationId).then(
                            () => {
                                successGrowl(vm.resource('PushNotifications_CancelNotification_SuccessMessage'));

                                //Mark DT object as cancelled
                                notification.isCancelled = true;

                                //Trigger row re-render
                                vm.reloadDataTable();
                            },
                            err => errorGrowl(err)
                        );
                    },
                    () => {}
                );
            },
            reloadNotifications(){
                const vm = this;
                
                vm.isLoading = true;
                
                api.listNotifications().then(
                    notifications => {
                        vm.notifications = notifications;
                        vm.reloadDataTable();
                        vm.isLoading = false;
                    },
                    err => {
                        errorGrowl(err);
                        vm.isLoading = false;
                    }
                );
            },
            reloadDataTable(){
                if(!this.$refs.table){
                    return;
                }

                this.$refs.table.reloadDataTable();
            }
        },
        watch: {
            canWrite(){
                this.reloadDataTable();
            }
        },
        computed: {
            columns(){
                const vm = this;
                
                
                const cancelButton = `
                    <button class="btn btn-outline-danger btm-sm pull-right">
                       <i class="fa fa-trash"></i>
                    </button>`;

                //Button needs to be wrapped in custom-button div in order to properly fire events
                const activeNotificationTemplate = `
                    <div class="custom-button" name="cancel">
                        <span>${vm.resource('PushNotifications_List_Status_Active')}</span>
                        ${vm.canWrite ? cancelButton : ''}
                    </div>
                `;

                const columns = [
                    { data: 'id', visible: false},
                    { data: 'isCancelled', visible: false },
                    { data: 'isExpired', visible: false },
                    { title: vm.resource('PushNotificationModel_Title_DisplayName'), data: 'title', render: textRenderer},
                    { title: vm.resource('PushNotificationModel_Message_DisplayName'), data: 'message', render: textRenderer},
                    { title: vm.resource('PushNotificationModel_Type_DisplayName'), data: 'type', width: '50px' },
                    { title: vm.resource('PushNotificationModel_ExpiresAt_DisplayName'), data: 'expiresAt', render: date => dateToString(date), width: '100px' },
                    { title: vm.resource('PushNotificationModel_Created_DisplayName'), data: 'created', render: date => dateToString(date), width: '100px' }
                ];

                columns.push({
                    title: vm.resource('PushNotificationModel_List_Status_DisplayName'),
                    data: null, //Setting data to null gives us the entire column to work with
                    render(data){
                        //Can't cancel twice
                        if(data.isCancelled){
                            return vm.resource('PushNotifications_List_Status_Cancelled');
                        }
                        
                        if(data.isExpired){
                            return vm.resource('PushNotifications_List_Status_Expired');
                        }
                        
                        return activeNotificationTemplate;
                    },
                    type: defaultContentType.button,
                    width: '125px',
                    orderable: false
                });

                return columns;
            },
            dataTablesOptions() {
                const createdIndex = this.columns.findIndex(c => c.data === 'created');
                
                
                return {
                    //Set default sorting to created
                    order: [[createdIndex, 'desc']],
                    createdRow: (tr, data) => {
                        //Lower opacity of all inactive rows
                        if(data.isExpired || data.isCancelled){
                            tr.classList.add('inactive');
                        }
                    }
                }
            }
        },
        data: () => ({
            tableFilterPosition: filterPositions.left,
            notifications: [],
            isLoading: true,
            canWrite: false
        })
    }
</script>

<style scoped lang="scss" src="../Style/list.scss">
</style>